import truncateLink from '../functions/truncate-link'

export default ({ Vue }) => {
    Vue.prototype.$truncateLink = truncateLink
}
